import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { yupResolver } from '@hookform/resolvers/yup';

import TurnForm from "../../components/turnForm";
import Representative from "../../components/representative";
import School from "../../components/school";

import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { getGrades, submit } from "../../redux/actionsAsync";
import { validation } from "../../utils/validation";

import LoadingModal from "../../components/loadingModal/LoadingModal";
import Info from "../../components/info";
import { Steps } from "antd";

import "../../assets/styles/Forms.css";

const { Step } = Steps;


const FormPage = () => {
  const { handleSubmit, register, control, setValue, getValues, setError, formState: { errors } } = useForm({
    resolver: yupResolver(validation),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { status } = useSelector(state => state.data);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [current, setCurrent] = useState(0);
  const [check, setCheck] = useState(false);


  useEffect(() => {
    dispatch(getGrades());
  }, [dispatch]);


  function next(e) {
    // let values = getValues();
    let values = getValues();


    if (current === 0) {
      setCheck(true);
      if (!values.name || !values.lastname || !values.dni || !values.mobilephone || !values.email || !values.cargo) {
        if (!values.name) {
          setError("name", { type: 'custom', message: 'Este campo es obligatorio' });
        }
        if (!values.lastname) {
          setError("lastname", { type: 'custom', message: 'Este campo es obligatorio' });
        }
        if (!values.dni) {
          setError("dni", { type: 'custom', message: 'Este campo es obligatorio' });
        }
        if (!values.mobilephone) {
          setError("mobilephone", { type: 'custom', message: 'Este campo es obligatorio' });
        }
        if (!values.email) {
          setError("email", { type: 'custom', message: 'Este campo es obligatorio' });
        }
        if (!values.cargo) {
          setError("cargo", { type: 'custom', message: 'Este campo es obligatorio' });
        }

        return;
      } else if (errors.name || errors.lastname || errors.dni || errors.mobilephone || errors.email || errors.cargo) {
        return;
      }
      else {
        setCheck(false);
        setCurrent(current + 1);
      }
    }
    else if (current === 1) {
      setCheck(true);

      if (!values.name_school) {
        setError("name_school", { type: 'custom', message: 'Este campo es obligatorio' });
        return;
      }
      else if (errors.name_school) {
        return;
      }
      else {
        setCheck(false);
        setCurrent(current + 1);
      }
    }

  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const handleSend = (values) => {
    if (values.id_turn === values.id_turn_2) {
      return Swal.fire({
        title: "Error!",
        text: "Los turnos no deben ser iguales, seleccione diferente día y horario.",
        icon: "error",
      });
    }
    setLoading(true);

    dispatch(submit(values))
      .then(response => {
        if (response.meta.requestStatus === "fulfilled") {

          setLoading(false);
          return Swal.fire({
            title: "¡Solicitud enviada!",
            text: "Los turnos se solicitaron exitosamente. En los próximos días recibirás su confirmación.",
            icon: "success",
            willClose: () => window.location.reload()
          });
        } else {
          setLoading(false);
          return Swal.fire({
            title: "¡Error!",
            text: `${response.payload.error ? response.payload.error : "Ocurrio un error, intentelo nuevamente"}`,
            icon: "error",
            willClose: () => window.location.reload()
          });
        }
      })
      .catch(err => {

        setLoading(false);
        return Swal.fire({
          title: "Error!",
          text: "Ocurrio un error, intentelo nuevamente",
          icon: "error",
          willClose: () => window.location.reload()
        });
      })
  };


  const steps = [
    {
      title: 'Paso 1',
      content: <Representative register={register} control={control} errors={errors} check={check} />,
    },
    {
      title: 'Paso 2',
      content: <School register={register} control={control} errors={errors} setValue={setValue} />,
    },
    {
      title: 'Paso 3',
      content: <TurnForm register={register} control={control} errors={errors} setValue={setValue} getValues={getValues} check={check} />,
    },
  ];


  return (
    <div className="seccion">
      <div className="form-container">
        <Info />

        <div className="form-title">
          Registrate para reservar una actividad
        </div>

        <div className="container form">
          <Form onSubmit={handleSubmit(handleSend)}>
            <Steps current={current} labelPlacement="vertical">
              {steps.map(item => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>

            {/* <div className="steps-content">{steps[current].content}</div> */}
            <div>
              {steps.map(({ title, content }, i) => (
                <div key={title} className={`${current === i ? "show" : "hiden"}`}>{content}</div>
              ))}
            </div>
            <div className="steps-action">
              {current > 0 && (
                <Button style={{ margin: '0 8px' }} onClick={() => prev()} className="prev-button">
                  Anterior
                </Button>
              )}
              {current < steps.length - 1 && (
                <Button onClick={() => next()} className="next-button">
                  Siguiente
                </Button>
              )}
              {current === steps.length - 1 && (
                // <Button type="primary" onClick={() => message.success('Processing complete!')}>
                //   Done
                // </Button>
                <Button variant="success" type="submit" className="next-button" >
                  Finalizar
                </Button>
              )}
            </div>
          </Form>
        </div>
      </div>
      {loading ? <LoadingModal show={status === "loading"} /> : ''}
    </div>
  )
};

export default FormPage;